import React, { useEffect } from 'react'
import ResetPasswordContent from 'src/components/Password/ResetPasswordContent/ResetPasswordContent'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'

const ResetPasswordPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <ResetPasswordContent />
      <Footer />
    </>
  )
}

export default ResetPasswordPage
